import { defineOverridesPreferences } from '@vben/preferences';

/**
 * @description 项目配置文件
 * 只需要覆盖项目中的一部分配置，不需要的配置不用覆盖，会自动使用默认配置
 * !!! 更改配置后请清空缓存，否则可能不生效
 */
export const overridesPreferences = defineOverridesPreferences({
  // overrides
  app: {
    isMobile: true,
    name: import.meta.env.VITE_APP_TITLE,
    authPageLayout: 'panel-center',
    accessMode: 'frontend',
    layout: 'full-content',
    enablePreferences: false,
    enableRefreshToken: true,
    loginExpiredMode: 'page',
  },
  breadcrumb: {
    enable: false,
  },
  shortcutKeys: {
    globalLockScreen: false,
    globalSearch: false,
  },
  sidebar: {
    collapsed: false,
  },
  tabbar: {
    enable: false,
  },
  widget: {
    fullscreen: false,
    globalSearch: false,
    languageToggle: false,
    lockScreen: false,
    notification: false,
    refresh: false,
    themeToggle: false,
  },
  theme: {
    mode: 'light',
  },
});
